/*
*  подключение документа с данными анкеты пациента
*/

import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import Twig from 'twig'
import serializer from 'form-serializer'
import mask from 'jquery-mask-plugin'
import datetimepicker from 'jquery-datetimepicker'
import "smartwizard/dist/css/smart_wizard_all.css"
import smartWizard from 'smartwizard'
import {Modal} from "bootstrap"

let qrcode = require('qrcode')


export default class extends Controller {
    static targets = [ "id"]
    WhoIs;
    printForm;
    lkToken;

    initialize() {
        super.initialize();

    }

    checkToken(){
        let token = sessionStorage.getItem('token');
        if (token !== null ){
            this.WhoIs = api.WhoIs();
            if(this.WhoIs.status === 500) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('userId');
                let nameVar = Twig.twig({ref: "authorization"}).render({});
                $('#authorization').html(nameVar)
            }
        } else {
            sessionStorage.removeItem('token');
            sessionStorage.removeItem('userId');
            let nameVar = Twig.twig({ref: "authorization"}).render({});
            $('#authorization').html(nameVar)
        }
    }


    goToDatabase() {
        this.checkToken();
        $('#titlePageBox').remove();
        $('#userdoc').remove();
        $('#template__header').after('' +
            '<div class="d-none d-sm-flex align-items-center mb-3 title-page__box" id="titlePageBox">' +
            '<h1 class="title-page">База данных клиентов</h1>' +
            '<div class="ms-auto" data-controller="database">' +
            '<button type="button" class="btn btn-light" data-action="click->database#addNewForm">Заполнить новую форму</button>' +
            '</div>' +
            '</div>' +
            '<div class="container-fluid database__main" id="database" data-controller="database"></div>');
    }

    printPage(){
        this.checkToken();
        window.print();
        //print();
    }

    deleteForm(event){
        this.checkToken();
        let deleteForm = api.deleteAnketa(event.params.id);
        $('#titlePageBox').remove();
        $('.xdsoft_datetimepicker').remove();
        $('#userdoc').remove();
        $('#template__header').after('' +
            '<div class="d-none d-sm-flex align-items-center mb-3 title-page__box" id="titlePageBox">' +
            '<h1 class="title-page">База данных клиентов</h1>' +
            '<div class="ms-auto" data-controller="database">' +
            '<button type="button" class="btn btn-light" data-action="click->database#addNewForm">Заполнить новую форму</button>' +
            '</div>' +
            '</div>' +
            '<div class="container-fluid database__main" id="database" data-controller="database"></div>');
        this.table.row($('#row-' + event.params.idpatient)).remove().draw();
    }

    fillDoc(){
        this.checkToken();
        let formUserId = $('#userdoc').attr('data-form');

        try{
            //вытаскиваем анкету по ID
            let userFormData = api.getAnketa(formUserId);
            this.lkToken = userFormData.Token;


            //вычисляем дату редактирования
            let dateEdit = new Date(userFormData.profileCreatedBY);
            let dayEdit = dateEdit.getDate();
            let monthEdit = dateEdit.getMonth() + 1;
            let hoursEdit = dateEdit.getHours();
            let minutesEdit = dateEdit.getMinutes();
            if(dayEdit < 10) {
                dayEdit = '0' + dayEdit
            }
            if(monthEdit < 10) {
                monthEdit = '0' + monthEdit
            }
            if(hoursEdit < 10) {
                hoursEdit = '0' + hoursEdit
            }
            if(minutesEdit < 10) {
                minutesEdit = '0' + minutesEdit
            }
            let anketaEdit = dayEdit + '.' + monthEdit + '.' + dateEdit.getFullYear() + ', ' + hoursEdit+ ':' + minutesEdit;
                //
            //выводим кнопки в анкету
            let doctorInfo = api.getDoctor(userFormData.CreatedBy);

            $('#anketaBtnBox').append('<div class="userdoc__btn-item" data-controller="database"><button type="button" class="btn btn-edit" data-action="click->database#copyForm" data-database-id-param="'+userFormData.ProfileID+'"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-edit"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg> Копировать</button></div>');

            if (doctorInfo.StaffID === this.WhoIs.StaffID) {
                $('#anketaBtnBox').append('<div class="userdoc__btn-item" data-controller="database"><button type="button" class="btn btn-edit" data-action="click->database#editForm" data-database-id-param="'+userFormData.ProfileID+'" data-database-patientid-param="'+userFormData.PatientID+'"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-edit"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>Редактировать</button></div>' +
                    '<div class="userdoc__btn-item"><button type="button" class="btn btn-delete" data-bs-toggle="modal" data-bs-target="#deleteAnketaModal-'+userFormData.ProfileID+'"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-delete"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="9" x2="15" y2="15"></line><line x1="15" y1="9" x2="9" y2="15"></line></svg> Удалить</button><div class="modal fade" id="deleteAnketaModal-'+userFormData.ProfileID+'" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"><div class="modal-dialog modal-dialog-centered"><div class="modal-content"><div class="modal-header"><h5 class="modal-title">АНКЕТА № '+userFormData.ProfileID+'<br>От '+anketaEdit+'</h5><button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button></div><div class="modal-body"><p>Вы точно хотите удалить анкету из базы?</p></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-bs-dismiss="modal">Нет, не удалять анкету</button><button type="button" data-action="click->userdoc#deleteForm" data-userdoc-id-param="'+userFormData.ProfileID+'" class="btn btn-danger" data-bs-dismiss="modal">удалить анкету</button></div></div></div></div></div>' +
                    '    <div class="userdoc__btn-item" data-controller="database"><button type="button" class="btn btn-toweb" data-action="click->database#towebForm" data-database-id-param="'+userFormData.ProfileID+'"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-toweb"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg> Записать в web</button>                        <div class="modal fade" id="towebForm'+userFormData.ProfileID+'" tabindex="-1" aria-hidden="true">\n' +
                    '                            <div class="modal-dialog">\n' +
                    '                                <div class="modal-content">\n' +
                    '                                    <div class="modal-header">\n' +
                    '                                        <h5 class="modal-title">Рецепты зарегистрированы</h5>\n' +
                    '                                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>\n' +
                    '                                    </div>\n' +
                    '                                    <div class="modal-body">\n' +
                    '                                        <div class="col-sm-12 mt-3"><ul id="towebFormList'+userFormData.ProfileID+'"></ul></div>\n' +
                    '                                    </div>\n' +
                    '                                </div>\n' +
                    '                            </div>\n' +
                    '                        </div></div>');
            }



            //createdAtDate
            let createdAnketa = new Date(userFormData.CreatedAt);
            let createdAtDay = createdAnketa.getDate();
            let createdAtMonth = createdAnketa.getMonth() + 1;
            let createdAtHours = createdAnketa.getHours();
            let createdAtMinutes = createdAnketa.getMinutes();
            if(createdAtDay < 10) {
                createdAtDay = '0' + createdAtDay
            }
            if(createdAtMonth < 10) {
                createdAtMonth = '0' + createdAtMonth
            }
            if (createdAtHours < 10){
                createdAtHours = '0' + createdAtHours
            }
            if (createdAtMinutes < 10){
                createdAtMinutes = '0' + createdAtMinutes
            }
            createdAnketa = createdAtDay + '.' + createdAtMonth + '.' + createdAnketa.getFullYear()+', ' + createdAtHours+ ':' + createdAtMinutes;
            $('#createdAtDate').text(createdAnketa);

            //личные данные
            $('#clientName').text(userFormData.ClientName);
            $('#clientSurname').text(userFormData.ClientSurname);
            $('#clientPhone').text(userFormData.Phone);

            /* превращаем дату в дд.мм.гггг.*/
            let date = new Date(userFormData.ClientDateBirth);
            let day = date.getDate();
            let month = date.getMonth() + 1;
            if(day < 10) {
                day = '0' + day
            }
            if(month < 10) {
                month = '0' + month
            }
            let ClientDateBirth = day + '.' + month + '.' + date.getFullYear();
            $('#clientDateBirth').text(ClientDateBirth);

            //склоняем в зависимости от числительных
            let clientAge = userFormData.ClientAge;
            function textAge(age) {
                let ageTxt;
                let ageCount = age % 100;
                if (ageCount >= 5 && ageCount <= 20) {
                    ageTxt = 'лет';
                } else {
                    ageCount = ageCount % 10;
                    if (ageCount === 1) {
                        ageTxt = 'год';
                    } else if (ageCount >= 2 && ageCount <= 4) {
                        ageTxt = 'года';
                    } else {
                        ageTxt = 'лет';
                    }
                }
                return ageTxt
            }
            $('#clientAge').html('' + userFormData.ClientAge + ' ' + textAge(clientAge))

            /* дата + время обращения в салон + превращаем дату в дд.мм.гггг.*/
            let dateCreate = new Date(userFormData.CreatedAt);
            let dayCreate = dateCreate.getDate();
            let monthCreate = dateCreate.getMonth() + 1;
            let hoursCreate = dateCreate.getHours();
            let minutesCreate = dateCreate.getMinutes();
            if(dayCreate < 10) {
                dayCreate = '0' + dayCreate
            }
            if(monthCreate < 10) {
                monthCreate = '0' + monthCreate
            }
            if(hoursCreate < 10) {
                hoursCreate = '0' + hoursCreate
            }
            if(minutesCreate < 10) {
                minutesCreate = '0' + minutesCreate
            }
            let anketaCreate = dayCreate + '.' + monthCreate + '.' + dateCreate.getFullYear() + ', ' + hoursCreate+ ':' + minutesCreate;
             $('#сreatedAt').text(anketaCreate);

            //дата следующего назначения + превращаем дату в дд.мм.гггг.
            if(userFormData.NextAppointmentDate !== null){
                let dateNextAppointment = new Date(userFormData.NextAppointmentDate);
                let dayNextAppointment = dateNextAppointment.getDate();
                let monthNextAppointment = dateNextAppointment.getMonth() + 1;
                if(dayNextAppointment < 10) {
                    dayNextAppointment = '0' + dayNextAppointment
                }
                if(monthNextAppointment < 10) {
                    monthNextAppointment = '0' + monthNextAppointment
                }
                let anketaNextAppointment = dayNextAppointment + '.' + monthNextAppointment + '.' + dateNextAppointment.getFullYear();
                $('#nextAppointmentDate').text(anketaNextAppointment);
            }


            let howFindUs = userFormData.HowFindUs;
            howFindUs.forEach((item)=>{
                let howFindUsItem;
                switch (item)
                {
                    case "noData":
                        howFindUsItem = 'Нет данных'
                        break;
                    case "site":
                        howFindUsItem = 'Сайт Actual Optic'
                        break;
                    case "internetAdv":
                        howFindUsItem = 'Реклама в интернете'
                        break;
                    case "facebook":
                        howFindUsItem = 'Facebook'
                        break;
                    case "instagram":
                        howFindUsItem = 'Instagram'
                        break;
                    case "2gis":
                        howFindUsItem = '2ГИС'
                        break;
                    case "googleMap":
                        howFindUsItem = 'Google карты'
                        break;
                    case "portal":
                        howFindUsItem = 'Другой портал'
                        break;
                    case "recommendation":
                        howFindUsItem = 'Рекомендация знакомых'
                        break;
                    case "livenearby":
                        howFindUsItem = 'Живу рядом'
                        break;
                    case "worknearby":
                        howFindUsItem = 'Работаю рядом'
                        break;
                    case "internetSearch":
                        howFindUsItem = 'Поиск в интернете'
                        break;
                    case "other":
                        howFindUsItem = 'Другое'
                        break;
                    case "clientActual":
                        howFindUsItem = 'клиент Actual Optic'
                        break;
                }

                $('#howFindUs').append('<li class="list-inline-item">' + howFindUsItem + '</li>')
            });

            $('#clientSymptomsDescription').text(userFormData.ClientSymptomsDescription);
            //$('#clientDoWithoutGlasses').text(userFormData.ClientDoWithoutGlasses);
            $('#clientProfession').text(userFormData.ClientProfession);

            let visualLoads = userFormData.VisualLoadsList;
            visualLoads.forEach((item)=>{
                let visualLoadsItem;
                switch (item)
                {
                    case "noData":
                        visualLoadsItem = 'Нет данных'
                        break;
                    case "car":
                        visualLoadsItem = 'автомобиль'
                        break;
                    case "office":
                        visualLoadsItem = 'работа в офисе'
                        break;
                    case "reading":
                        visualLoadsItem = 'чтение бумажных текстов'
                        break;
                    case "drawing":
                        visualLoadsItem = 'шитье, вязание, рисование'
                        break;
                    case "prices":
                        visualLoadsItem = 'цены в магазине'
                        break;
                    case "tv":
                        visualLoadsItem = 'телевизор'
                        break;
                    case "sports":
                        visualLoadsItem = 'занятия спортом'
                        break;
                    case "computer":
                        visualLoadsItem = 'компьютер, ноутбук, планшет'
                        break;
                    case "instructions":
                        visualLoadsItem = 'инструкция от  лекарств'
                        break;
                    case "phone":
                        visualLoadsItem = 'использование телефона'
                        break;
                    case "other":
                        visualLoadsItem = 'хобби, другое'
                        break;
                }

                $('#visualLoadsList').append('<li>' + visualLoadsItem + '</li>')
            });

            let improveVision = userFormData.ImproveVisionList;
            improveVision.forEach((item)=>{
                let improveVisionItem;
                switch (item)
                {
                    case "noData":
                        improveVisionItem = 'Нет данных'
                        break;
                    case "allDistances":
                        improveVisionItem = 'на все расстояния'
                        break;
                    case "along":
                        improveVisionItem = 'вдаль'
                        break;
                    case "averageDistance":
                        improveVisionItem = 'среднее расстояние'
                        break;
                    case "near":
                        improveVisionItem = 'вблизи'
                        break;
                }
                $('#improveVisionList').append('<li>' + improveVisionItem + '</li>')
            });



            // доктор
            let doctorName = api.getDoctor(userFormData.CreatedBy);
            $('#createdBy').text(doctorName.Name)

            console.debug(userFormData)
            console.debug(userFormData.CreatedBy)
            console.debug(doctorName)



            //предыдущие очки - выборка
            let previousGlassesList = userFormData.PreviousGlassesList;
            let previousGlassesListItem;
            switch (previousGlassesList)
            {
                case "NoData":
                    previousGlassesListItem = 'нет данных'
                    break;
                case "distance":
                    previousGlassesListItem = 'для дали'
                    break;
                case "proximity":
                    previousGlassesListItem = 'для близи'
                    break;
                case "permanent":
                    previousGlassesListItem = 'для постоянного ношения'
                    break;
                case "noGlass":
                    previousGlassesListItem = 'не было предыдущих очков'
                    break;
            }
            $('#previousGlassesList').text(previousGlassesListItem)

            if (previousGlassesList === 'noGlass'){
                $('.noGlass').addClass('d-none');
            }

            // предыдущие очки - таблица. поля необязательны, проверяем на null
            let previousGlasses = userFormData.PreviousGlasses;
            if(previousGlasses !== null){
                $('#previousGlasses-sph-r').text(previousGlasses.r.sph);
                $('#previousGlasses-cyl-r').text(previousGlasses.r.cyl);
                $('#previousGlasses-ax-r').text(previousGlasses.r.ax);
                $('#previousGlasses-pr-r').text(previousGlasses.r.pr);
                $('#previousGlasses-bas-r').text(previousGlasses.r.bas);
                $('#previousGlasses-add-r').text(previousGlasses.r.add);
                $('#previousGlasses-rc-r').text(previousGlasses.r.rc);
                $('#previousGlasses-vis-r').text(previousGlasses.r.vis);
                $('#previousGlasses-sph-l').text(previousGlasses.l.sph);
                $('#previousGlasses-cyl-l').text(previousGlasses.l.cyl);
                $('#previousGlasses-ax-l').text(previousGlasses.l.ax);
                $('#previousGlasses-pr-l').text(previousGlasses.l.pr);
                $('#previousGlasses-bas-l').text(previousGlasses.l.bas);
                $('#previousGlasses-add-l').text(previousGlasses.l.add);
                $('#previousGlasses-rc-l').text(previousGlasses.l.rc);
                $('#previousGlasses-vis-l').text(previousGlasses.l.vis);
            }
            // предыдущие очки - textarea - поля необязательны, проверяем на null
            if(userFormData.LandFeatures !== null){
                $('#clientOldGlasses').text(userFormData.LandFeatures);
            }

            //Предыдущие контактные линзы
            let previousLensType = userFormData.PreviousLensType;
            let previousLensTypetItem;
            switch (previousLensType)
            {
                case "noData":
                    previousLensTypetItem = 'нет данных'
                    break;
                case "constant":
                    previousLensTypetItem = 'постоянного ношения'
                    break;
                case "noConstant":
                    previousLensTypetItem = 'непостоянного ношения'
                    break;
                case "noLens":
                    previousLensTypetItem = 'не было предыдущих контактных линз'
                    break;
            }
            $('#previousLensType').text(previousLensTypetItem)

            if (previousLensType === 'noLens'){
                $('.noLens').addClass('d-none');
            }
            // предыдущие контактные линзы - таблица. поля необязательны, проверяем на null
            let PreviousLensTable = userFormData.PreviousLens;
            if(PreviousLensTable !== null){
                $('#previousLensOD-sph').text(userFormData.PreviousLens.OD.sph);
                $('#previousLensOD-cyl').text(userFormData.PreviousLens.OD.cyl);
                $('#previousLensOD-ax').text(userFormData.PreviousLens.OD.ax);
                $('#previousLensOD-add').text(userFormData.PreviousLens.OD.add);
                $('#previousLensOD-bc').text(userFormData.PreviousLens.OD.bc);
                $('#previousLensOD-dia').text(userFormData.PreviousLens.OD.dia);
                $('#previousLensOS-sph').text(userFormData.PreviousLens.OS.sph);
                $('#previousLensOS-cyl').text(userFormData.PreviousLens.OS.cyl);
                $('#previousLensOS-ax').text(userFormData.PreviousLens.OS.ax);
                $('#previousLensOS-add').text(userFormData.PreviousLens.OS.add);
                $('#previousLensOS-bc').text(userFormData.PreviousLens.OS.bc);
                $('#previousLensOS-dia').text(userFormData.PreviousLens.OS.dia);
            }


            //симптоматические жалобы
            let symptomaticComplaints = userFormData.SymptomaticComplaints;
            let symptomaticItem;
            function symptomaticTimes(time){
                switch (time)
                {
                    case "1":
                        symptomaticItem = '1 раз в неделю'
                        break;
                    case "2":
                        symptomaticItem = 'месяц'
                        break;
                    case "3":
                        symptomaticItem = 'полгода'
                        break;
                    case "rarely":
                        symptomaticItem = 'Редко'
                        break;
                    case "constantly":
                        symptomaticItem = 'Постоянно'
                        break;
                    case "stress":
                        symptomaticItem = 'После зрительной нагрузки'
                        break;
                }
            }

            if(symptomaticComplaints.headaches !== ""){
                symptomaticTimes(symptomaticComplaints.headaches);
                $('#symptomaticComplaints').append('<li>Головные боли - ' + symptomaticItem  +' </li>')
            }
            if(symptomaticComplaints.brightLight !== ""){
                symptomaticTimes(symptomaticComplaints.brightLight);
                $('#symptomaticComplaints').append('<li>Раздражает яркий свет - ' + symptomaticItem  +' </li>')
            }
            if(symptomaticComplaints.focus !== ""){
                symptomaticTimes(symptomaticComplaints.focus);
                $('#symptomaticComplaints').append('<li>Трудно перевести взгляд и сфокусировать его - ' + symptomaticItem  +' </li>')
            }
            if(symptomaticComplaints.noClarity !== ""){
                symptomaticTimes(symptomaticComplaints.noClarity);
                $('#symptomaticComplaints').append('<li>Нет четкости вблизи - ' + symptomaticItem  +' </li>')
            }
            if(symptomaticComplaints.twilight !== ""){
                symptomaticTimes(symptomaticComplaints.twilight);
                $('#symptomaticComplaints').append('<li>Плохо видно в сумерках - ' + symptomaticItem  +' </li>')
            }
            if(symptomaticComplaints.redness !== ""){
                symptomaticTimes(symptomaticComplaints.redness);
                $('#symptomaticComplaints').append('<li>Усталость и покраснение глаз - ' + symptomaticItem  +' </li>')
            }
            if(symptomaticComplaints.close !== ""){
                symptomaticTimes(symptomaticComplaints.close);
                $('#symptomaticComplaints').append('<li>Хочется закрыть один глаз - ' + symptomaticItem  +' </li>')
            }
            if(symptomaticComplaints.headaches === "" &&
                symptomaticComplaints.brightLight === "" &&
                symptomaticComplaints.focus === "" &&
                symptomaticComplaints.noClarity === "" &&
                symptomaticComplaints.twilight === "" &&
                symptomaticComplaints.redness === "" &&
                symptomaticComplaints.close === "") {
                $('#symptomaticComplaints').append('<li>Жалоб нет</li>')
            }

            // заболевания, операции, лекарства, учет
            $('#clientEyeSurgeries').text(userFormData.ClientEyeSurgeries);
            $('#clientChronic').text(userFormData.ClientChronic);
            $('#clientMedications').text(userFormData.ClientMedications);
            $('#clientOphthalmologist').text(userFormData.ClientOphthalmologist);
            $('#clientExamination').text(userFormData.ClientExamination);

            //Авторефрактометрия таблица
            $('#autorefractometry-OSax').text(userFormData.Autorefractometry.OS.ax);
            $('#autorefractometry-OSSph').text(userFormData.Autorefractometry.OS.sph);
            $('#autorefractometry-OScyl').text(userFormData.Autorefractometry.OS.cyl);
            $('#autorefractometry-ODax').text(userFormData.Autorefractometry.OD.ax);
            $('#autorefractometry-ODSph').text(userFormData.Autorefractometry.OD.sph);
            $('#autorefractometry-ODcyl').text(userFormData.Autorefractometry.OD.cyl);

            //Кератометрия таблица
            $('#keratometry-ODcyl').text(userFormData.Keratometry.OD.cyl);
            $('#keratometry-ODax').text(userFormData.Keratometry.OD.ax);
            $('#keratometry-OScyl').text(userFormData.Keratometry.OS.cyl);
            $('#keratometry-OSax').text(userFormData.Keratometry.OS.ax);



            //Cover тест
            let preliminaryTestItem;
            function preliminaryTestname(name){
                switch (name)
                {
                    case "noData":
                        preliminaryTestItem = 'Нет данных'
                        break;
                    case "esophoria":
                        preliminaryTestItem = 'эзофория'
                        break;
                    case "exophoria":
                        preliminaryTestItem = 'экзофория'
                        break;
                    case "esotropia":
                        preliminaryTestItem = 'эзотропия'
                        break;
                    case "exotropia":
                        preliminaryTestItem = 'экзотропия'
                        break;
                    case "ortoforia":
                        preliminaryTestItem = 'ортофория'
                        break;
                }
            }

            let preliminaryTestDistance = userFormData.PreliminaryTest.distanse;
            preliminaryTestDistance.forEach((item)=>{
                preliminaryTestname(item);
                $('#preliminaryTestDistanse').append('<li>' + preliminaryTestItem + '</li>')
            });
            let preliminaryTestNear = userFormData.PreliminaryTest.near;
            if(preliminaryTestNear !== undefined){
                preliminaryTestNear.forEach((item)=>{
                    preliminaryTestname(item);
                    $('#preliminaryTestNear').append('<li>' + preliminaryTestItem + '</li>')
                });
            }



            //Девиация по Гиршбергу таблица
            $('#girshberg-OD').text(userFormData.Girshberg.OD);
            $('#girshberg-OS').text(userFormData.Girshberg.OS);


            //Подвижность глазных яблок
            if(userFormData.MobilityEyeballsLimitationMuscles === null && userFormData.MobilityEyeballsNerveParesis === null) {
                $('.mobilityEyeballs').addClass('d-none');
            } else {
                $('#mobilityEyeballs-limitationMuscles').text(userFormData.MobilityEyeballsLimitationMuscles);
                $('#mobilityEyeballs-nerveParesis').text(userFormData.MobilityEyeballsNerveParesis);
                $('#mobilityEyeballs-full').addClass('d-none');
            }

            //Ближайшая точка конвергенции
            $('#btk').text(userFormData.Btk);

            //PD монокулярно таблица
            /*          $('#pdMonocular-OD-distance').text(userFormData.PdMonocular.OD.distance);
                      $('#pdMonocular-OD-near').text(userFormData.PdMonocular.OD.near);
                      $('#pdMonocular-OS-distance').text(userFormData.PdMonocular.OS.distance);
                      $('#pdMonocular-OS-near').text(userFormData.PdMonocular.OS.near);*/


            //VISUS без коррекции таблица
            $('#visusWithoutCorrection-distance-OD').text(userFormData.VisusWithoutCorrection.distance.OD);
            $('#visusWithoutCorrection-distance-OS').text(userFormData.VisusWithoutCorrection.distance.OS);
            $('#visusWithoutCorrection-distance-OU').text(userFormData.VisusWithoutCorrection.distance.OU);
            $('#visusWithoutCorrection-near-OD').text(userFormData.VisusWithoutCorrection.near.OD);
            $('#visusWithoutCorrection-near-OS').text(userFormData.VisusWithoutCorrection.near.OS);
            $('#visusWithoutCorrection-near-OU').text(userFormData.VisusWithoutCorrection.near.OU);



            //С коррекцией «лучшей» сферой таблица
            $('#correctionBestSphereOD-sph').text(userFormData.CorrectionBestSphere.OD.sph.value);
            $('#correctionBestSphereOD-sph-main').text(userFormData.CorrectionBestSphere.OD.sph.main);
            $('#correctionBestSphereOD-sph-main-equally').text(userFormData.CorrectionBestSphere.OD.sph.equally);
            $('#correctionBestSphereOD-cyl').text(userFormData.CorrectionBestSphere.OD.cyl);
            $('#correctionBestSphereOD-ax').text(userFormData.CorrectionBestSphere.OD.ax);
            $('#correctionBestSphereOD-equally').text(userFormData.CorrectionBestSphere.OD.equally);
            $('#correctionBestSphereOS-sph').text(userFormData.CorrectionBestSphere.OS.sph.value);
            $('#correctionBestSphereOS-sph-main').text(userFormData.CorrectionBestSphere.OS.sph.main);
            $('#correctionBestSphereOS-sph-main-equally').text(userFormData.CorrectionBestSphere.OS.sph.equally);
            $('#correctionBestSphereOS-cyl').text(userFormData.CorrectionBestSphere.OS.cyl);
            $('#correctionBestSphereOS-ax').text(userFormData.CorrectionBestSphere.OS.ax);
            $('#correctionBestSphereOS-equally').text(userFormData.CorrectionBestSphere.OS.equally);
            $('#correctionBestSphere-OU').text(userFormData.CorrectionBestSphere.OU);

            //Уточняем сферу таблица
            $('#clarifying-OD').text(userFormData.Clarifying.OD);
            $('#clarifying-OS').text(userFormData.Clarifying.OS);

            //Уточняем cyl таблица
            $('#specifyingCyl1-sph').text(userFormData.SpecifyingCyl.OD.sph);
            $('#specifyingCyl1-cyl').text(userFormData.SpecifyingCyl.OD.cyl);
            $('#specifyingCyl1-ax').text(userFormData.SpecifyingCyl.OD.ax);
            $('#specifyingCyl1-equally').text(userFormData.SpecifyingCyl.OD.equally);
            $('#specifyingCyl2-sph').text(userFormData.SpecifyingCyl.OS.sph);
            $('#specifyingCyl2-cyl').text(userFormData.SpecifyingCyl.OS.cyl);
            $('#specifyingCyl2-ax').text(userFormData.SpecifyingCyl.OS.ax);
            $('#specifyingCyl2-equally').text(userFormData.SpecifyingCyl.OS.equally);


            //Ведущий глаз выборка radio
            let leadingEye = userFormData.LeadingEye;
            if (leadingEye === 'noData'){
                $('#leadingEye').text('Нет данных');
            } else {
                $('#leadingEye').text(leadingEye);
            }


            //Проверяем отсутствие грубых бинокулярных нарушений выборка radio
            let binocularDisorders = userFormData.BinocularDisorders;
            let binocularDisordersItem;
            switch (binocularDisorders)
            {
                case "noData":
                    binocularDisordersItem = 'Нет данных'
                    break;
                case "yes":
                    binocularDisordersItem = 'Да'
                    break;
                case "no":
                    binocularDisordersItem = 'Нет'
                    break;
            }
            $('#binocularDisorders').text(binocularDisordersItem)



            //измеряем ПТА таблица
            $('#pta-OD-Sph').text(userFormData.Pta.OD.sph);
            $('#pta-OS-Sph').text(userFormData.Pta.OS.sph);

            //Аккомодационно-рефракционный баланс
            $('#accommodationRefractiveBalance-OD-sph').text(userFormData.AccommodationRefractiveBalance.OD.sph);
            $('#accommodationRefractiveBalance-OS-sph').text(userFormData.AccommodationRefractiveBalance.OS.sph);

            //Острота зрения вдаль таблица
            $('#visualDistance-OU').text(userFormData.VisualDistance.OU);
            $('#visualDistance-OS').text(userFormData.VisualDistance.OS);
            $('#visualDistance-OD').text(userFormData.VisualDistance.OD);

            //Характер зрения выборка radio
            let natureVision = userFormData.NatureVision;
            let natureVisionItem;
            switch (natureVision)
            {
                case "binocular":
                    natureVisionItem = 'бинокулярное'
                    break;
                case "monocular":
                    natureVisionItem = 'монокулярное OD/OS'
                    break;
                case "simultaneous-ezo":
                    natureVisionItem = 'одновременное (тип: эзо)'
                    break;
                case "simultaneous-exo":
                    natureVisionItem = 'одновременное (тип: экзо)'
                    break;
            }
            $('#natureVision').text(natureVisionItem);

            //тест Шобера выборка radio
            let schoberTest = userFormData.SchoberTest;
            let schoberTestItem;
            switch (schoberTest)
            {
                case "schoberTest-orthophoria":
                    schoberTestItem = 'ортофория'
                    break;
                case "schoberTest-esophoria":
                    schoberTestItem = 'эзофория'
                    break;
                case "schoberTest-exophoria":
                    schoberTestItem = 'экзофория'
                    break;
            }
            $('#schoberTest').text(schoberTestItem);

            //Кресты
            $('#cross-withoutFixation').text(userFormData.CrossWithoutFixsation);
            $('#cross-fixation').text(userFormData.CrossFixsaton);

            //Анизейкония
            $('#aniseikonia-staples').text(userFormData.AniseikoniaStaples);

            //Стереотесты выборка radio + поле
            let stereotests = userFormData.StereoTests.yn;
            let stereotestsItem;
            switch (stereotests)
            {
                case "yes":
                    stereotestsItem = 'есть'
                    break;
                case "no":
                    stereotestsItem = 'нет'
                    break;
                case "threshold":
                    stereotestsItem = 'нарушен порог'
                    break;
            }
            $('#stereotests').text(stereotestsItem)


            //Призмы таблица
            $('#prismsOD-sph').text(userFormData.Prisms.OD.sph);
            $('#prismsOD-cyl').text(userFormData.Prisms.OD.cyl);
            $('#prismsOD-ax').text(userFormData.Prisms.OD.ax);
            $('#prismsOD-pr1').text(userFormData.Prisms.OD.pr1);
            $('#prismsOD-bas').text(userFormData.Prisms.OD.bas);
            $('#prismsOD-pr2').text(userFormData.Prisms.OD.pr2);
            $('#prismsOD-bas2').text(userFormData.Prisms.OD.bas2);
            $('#prismsOD-VIS').text(userFormData.Prisms.OD.VIS);
            $('#prismsOD-PD').text(userFormData.Prisms.OD.PD);
            $('#prismsOS-sph').text(userFormData.Prisms.OS.sph);
            $('#prismsOS-cyl').text(userFormData.Prisms.OS.cyl);
            $('#prismsOS-ax').text(userFormData.Prisms.OS.ax);
            $('#prismsOS-pr1').text(userFormData.Prisms.OS.pr1);
            $('#prismsOS-bas').text(userFormData.Prisms.OS.bas);
            $('#prismsOS-pr2').text(userFormData.Prisms.OS.pr2);
            $('#prismsOS-bas2').text(userFormData.Prisms.OS.bas2);
            $('#prismsOS-VIS').text(userFormData.Prisms.OS.VIS);
            $('#prismsOS-PD').text(userFormData.Prisms.OS.PD);
            $('#prismsOSOD-OU').text(userFormData.Prisms.OSOD.OU);
            $('#prismReversal').text(userFormData.PrismReversal);

            //Исследование аккомодации таблица
            $('#accommodationResearch-vis').text(userFormData.AccommodationResearch.vis);
            $('#accommodationResearch-volumePPOD').text(userFormData.AccommodationResearch.volume.PP.OD);
            $('#accommodationResearch-volumePPOS').text(userFormData.AccommodationResearch.volume.PP.OS);
            $('#accommodationResearch-volumeОААOS').text(userFormData.AccommodationResearch.volume.oaa.OS);
            $('#accommodationResearch-volumeОААOD').text(userFormData.AccommodationResearch.volume.oaa.OD);


            if(userFormData.AccommodationResearch.comfort.OD !== ''){
                $('#accommodationResearch-comfortPPOD').text(userFormData.AccommodationResearch.comfort.OD);
            } else {
                $('#accommodationResearch-comfortPPOD').text(' - ');
            }
            if(userFormData.AccommodationResearch.comfort.OS !== ''){
                $('#accommodationResearch-comfortPPOS').text(userFormData.AccommodationResearch.comfort.OS);
            }  else {
                $('#accommodationResearch-comfortPPOS').text(' - ');
            }



            if(userFormData.AccommodationResearch.zoa !== ""){
                $('#accommodationResearch-zoa').text(userFormData.AccommodationResearch.zoa);
            } else {
                $('#accommodationResearch-zoa').text(' - ');
            }


            if(userFormData.AccommodationResearch.flexibility.OD !== ""){
                $('#flexibilityAccommodation-OD').text(userFormData.AccommodationResearch.flexibility.OD);
            } else {
                $('#flexibilityAccommodation-OD').text(' - ');
            }
            if(userFormData.AccommodationResearch.flexibility.OS !== ""){
                $('#flexibilityAccommodation-OS').text(userFormData.AccommodationResearch.flexibility.OS);
            } else {
                $('#flexibilityAccommodation-OS').text(' - ');
            }
            if(userFormData.AccommodationResearch.flexibility.OU !== ""){
                $('#flexibilityAccommodation-OU').text(userFormData.AccommodationResearch.flexibility.OU);
            } else {
                $('#flexibilityAccommodation-OU').text(' - ');
            }



            if(userFormData.AccommodationResearch.addition !== ""){
                $('#addition-OU').text(userFormData.AccommodationResearch.addition);
            } else {
                $('#addition-OU').text(' - ');
            }

            if(userFormData.AccommodationResearch.refinement.pushUpTest !== ""){
                $('#refinementAddition-pushUpTest').text(userFormData.AccommodationResearch.refinement.pushUpTest);
            } else {
                $('#refinementAddition-pushUpTest').text(' - ');
            }
            if(userFormData.AccommodationResearch.refinement.add !== ""){
                $('#refinementAddition-add').text(userFormData.AccommodationResearch.refinement.add);
            } else {
                $('#refinementAddition-add').text(' - ');
            }
            if(userFormData.AccommodationResearch.refinement.gridTest !== ""){
                $('#refinementAddition-GridTest').text(userFormData.AccommodationResearch.refinement.gridTest);
            } else {
                $('#refinementAddition-GridTest').text(' - ');
            }

            if(userFormData.AccommodationResearch.balanceNear.OD !== ""){
                $('#balanceNear-OD').text(userFormData.AccommodationResearch.balanceNear.OD);
            } else {
                $('#balanceNear-OD').text(' - ');
            }
            if(userFormData.AccommodationResearch.balanceNear.OS !== ""){
                $('#balanceNear-OS').text(userFormData.AccommodationResearch.balanceNear.OS);
            } else {
                $('#balanceNear-OS').text(' - ');
            }


            if(userFormData.AccommodationResearch.btk !== ""){
                $('#accommodationResearch-btk').text(userFormData.AccommodationResearch.btk);
            } else {
                $('#accommodationResearch-btk').text(' - ');
            }


            if(userFormData.AccommodationResearch.measurePhoria.howell !== ""){
                $('#measurePhoria-howell').text(userFormData.AccommodationResearch.measurePhoria.howell);
            } else {
                $('#measurePhoria-howell').text(' - ');
            }

            if(userFormData.AccommodationResearch.measurePhoria.torrington !== ""){
                $('#measurePhoria-torrington').text(userFormData.AccommodationResearch.measurePhoria.torrington);
            } else {
                $('#measurePhoria-torrington').text(' - ');
            }

            if(userFormData.AccommodationResearch.measurePhoria.POSB !== ""){
                $('#measurePhoria-POSB').text(userFormData.AccommodationResearch.measurePhoria.POSB);
            } else {
                $('#measurePhoria-POSB').text(' - ');
            }

            if(userFormData.AccommodationResearch.pm10.ak !== ""){
                $('#accommodationResearch-ak').text(userFormData.AccommodationResearch.pm10.ak);
            } else {
                $('#accommodationResearch-ak').text(' - ');
            }

            if(userFormData.AccommodationResearch.pm10.prismReversal !== ""){
                $('#accommodationResearch-prismReversal').text(userFormData.AccommodationResearch.pm10.prismReversal);
            } else {
                $('#accommodationResearch-prismReversal').text(' - ');
            }

            if(userFormData.AccommodationResearch.pm11.finalAddition !== ""){
                $('#accommodationResearch-finalAddition').text(userFormData.AccommodationResearch.pm11.finalAddition);
            } else {
                $('#accommodationResearch-finalAddition').text(' - ');
            }

            if(userFormData.AccommodationResearch.pm11.visualAcuityNear !== ""){
                $('#visual-acuity-near').text(userFormData.AccommodationResearch.pm11.visualAcuityNear);
            } else {
                $('#visual-acuity-near').text(' - ');
            }

            if(userFormData.AccommodationResearch.pm11.OU !== ""){
                $('#accommodationResearch-OU').text(userFormData.AccommodationResearch.pm11.OU);
            } else {
                $('#accommodationResearch-OU').text(' - ');
            }

            //рецепт на очки - деполтный
            // вырезать из массива пераый элемент, поставить в форму.
            let receiptGlass0 = userFormData.ReceiptGlass.shift();

            //Рецепт на очки VISUS до и после
            $('#receiptGlassOD-visus-before').text(receiptGlass0.OD.visus.before==='0'?'':receiptGlass0.OD.visus.before);
            $('#receiptGlassOS-visus-before').text(receiptGlass0.OS.visus.before==='0'?'':receiptGlass0.OS.visus.before);
            $('#receiptGlassOD-visus-after').text(receiptGlass0.OD.visus.after==='0'?'':receiptGlass0.OD.visus.after);
            $('#receiptGlassOS-visus-after').text(receiptGlass0.OS.visus.after==='0'?'':receiptGlass0.OS.visus.after);
            if (receiptGlass0.OD.visus.before === '0'){
                $('#receiptGlassOD-visus-before').closest('.receipt-td-200').addClass('d-print-none')
            } else {
                $('#receiptGlassOD-visus-before').closest('.receipt-td-200').removeClass('d-print-none')
            }
            if (receiptGlass0.OS.visus.before === '0'){
                $('#receiptGlassOS-visus-before').closest('.receipt-td-200').addClass('d-print-none')
            } else {
                $('#receiptGlassOS-visus-before').closest('.receipt-td-200').removeClass('d-print-none')
            }
            if (receiptGlass0.OD.visus.after === '0'){
                $('#receiptGlassOD-visus-after').closest('.receipt-td-200').addClass('d-print-none')
            } else {
                $('#receiptGlassOD-visus-after').closest('.receipt-td-200').removeClass('d-print-none')
            }
            if (receiptGlass0.OS.visus.after === '0'){
                $('#receiptGlassOS-visus-after').closest('.receipt-td-200').addClass('d-print-none')
            } else {
                $('#receiptGlassOS-visus-after').closest('.receipt-td-200').removeClass('d-print-none')
            }
            if (receiptGlass0.OD.visus.before === '0' && receiptGlass0.OS.visus.before === '0') {
                $('#receiptGlassOD-visus-before').closest('.table').addClass('d-print-none')
            } else {
                $('#receiptGlassOD-visus-before').closest('.table').removeClass('d-print-none')
            }
            if (receiptGlass0.OD.visus.after === '0' && receiptGlass0.OS.visus.after === '0') {
                $('#receiptGlassOD-visus-after').closest('.table').addClass('d-print-none')
            } else {
                $('#receiptGlassOD-visus-after').closest('.table').removeClass('d-print-none')
            }



            //Рецепт на очки таблица
            let receiptGlassODSph = Number(receiptGlass0.OD.sph);

            if(receiptGlassODSph === 0){
                $('#receiptGlassOD-sph').text('')
            } else if(receiptGlassODSph > 0) {
                $('#receiptGlassOD-sph').text('+' + receiptGlassODSph);
            } else {
                $('#receiptGlassOD-sph').text(receiptGlassODSph);
            }

            //$('#receiptGlassOD-sph').text(receiptGlass0.OD.sph==='0'?'':receiptGlass0.OD.sph);
            $('#receiptGlassOD-cyl').text(receiptGlass0.OD.cyl==='0'?'':receiptGlass0.OD.cyl);
            $('#receiptGlassOD-ax').text(receiptGlass0.OD.ax==='0'?'':receiptGlass0.OD.ax);
            $('#receiptGlassOD-add').text(receiptGlass0.OD.add==='0'?'':receiptGlass0.OD.add);
            $('#receiptGlassOD-pr1').text(receiptGlass0.OD.pr1==='0'?'':receiptGlass0.OD.pr1);
            $('#receiptGlassOD-bas1').text(receiptGlass0.OD.bas1==='0'?'':receiptGlass0.OD.bas1);
            $('#receiptGlassOD-pr2').text(receiptGlass0.OD.pr2==='0'?'':receiptGlass0.OD.pr2);
            $('#receiptGlassOD-bas2').text(receiptGlass0.OD.bas2==='0'?'':receiptGlass0.OD.bas2);

            let receiptGlassOSSph = Number(receiptGlass0.OS.sph);
            if(receiptGlassOSSph === 0){
                $('#receiptGlassOS-sph').text('')
            } else if(receiptGlassOSSph > 0) {
                $('#receiptGlassOS-sph').text('+' + receiptGlassOSSph);
            } else {
                $('#receiptGlassOS-sph').text(receiptGlassOSSph);
            }
            //$('#receiptGlassOS-sph').text(receiptGlass0.OS.sph==='0'?'':receiptGlass0.OS.sph);
            $('#receiptGlassOS-cyl').text(receiptGlass0.OS.cyl==='0'?'':receiptGlass0.OS.cyl);
            $('#receiptGlassOS-ax').text(receiptGlass0.OS.ax==='0'?'':receiptGlass0.OS.ax);
            $('#receiptGlassOS-add').text(receiptGlass0.OS.add==='0'?'':receiptGlass0.OS.add);
            $('#receiptGlassOS-pr1').text(receiptGlass0.OS.pr1==='0'?'':receiptGlass0.OS.pr1);
            $('#receiptGlassOS-bas1').text(receiptGlass0.OS.bas1==='0'?'':receiptGlass0.OS.bas1);
            $('#receiptGlassOS-pr2').text(receiptGlass0.OS.pr2==='0'?'':receiptGlass0.OS.pr2);
            $('#receiptGlassOS-bas2').text(receiptGlass0.OS.bas2==='0'?'':receiptGlass0.OS.bas2);

            //Рецепт на очки основание выборка radio

            let footing = receiptGlass0.footing;

            let footingItem;
            switch (footing)
            {
                case "bi":
                    footingItem = 'BI (основание внутрь)'
                    break;
                case "bo":
                    footingItem = 'BO (основание к виску)'
                    break;
                case "bu":
                    footingItem = 'BU (основание вверх)'
                    break;
                case "bd":
                    footingItem = 'BD (основание вниз)'
                    break;
            }

            $('#footing-display').text(footingItem)
            $('#footing').text(footingItem)

            //РЦ даль + близь
            $('#receiptGlassOD-rc-distance').text(receiptGlass0.OD.rc.distance==='0'?'':receiptGlass0.OD.rc.distance);
            $('#receiptGlassOS-rc-distance').text(receiptGlass0.OS.rc.distance==='0'?'':receiptGlass0.OS.rc.distance);
            $('#receiptGlassOD-rc-near').text(receiptGlass0.OD.rc.near==='0'?'':receiptGlass0.OD.rc.near);
            $('#receiptGlassOS-rc-near').text(receiptGlass0.OS.rc.near==='0'?'':receiptGlass0.OS.rc.near);

            //Рецепт на очки очки линзы список checkbox
            let glassLenses = receiptGlass0.lenses;
            if(glassLenses !== undefined){
                glassLenses.forEach((item)=>{
                    $('.receiptGlassLensValidation__box input[value="' + item +'"]').prop('checked', true)
                });
            }


            //Рецепт на очки очки линзы список checkbox
            let glassLensesType = receiptGlass0.lensesType;
            if(glassLensesType !== undefined){
                glassLensesType.forEach((item)=>{
                    $('.receiptGlassTypeLensValidation__box input[value="' + item +'"]').prop('checked', true)
                });
            }

            //рекомендуемая оптическая линза recommendedCoatedLens
            $('#recommendedCoatedLens').text(receiptGlass0.recommendedCoatedLens);

            //Рецепт на очки рекомендации, примечания,диагноз
            $('#receiptGlass-recommendations').text(receiptGlass0.recommendations);
            $('#receiptGlass-notes').text(receiptGlass0.notes);
            $('#receiptGlass-diagnosis').text(receiptGlass0.diagnosis);


            //рецепт на очки - генерация
            //  уже вырезан первый элемент - он для дефолта. а этот остаток для генерации
            userFormData.ReceiptGlass.forEach(function(item, index) {
                index++;
                let footingItemGen = item.footing;
                let footingtext;
                switch (footingItemGen)
                {
                    case "bi":
                        footingtext = 'BI (основание внутрь)'
                        break;
                    case "bo":
                        footingtext = 'BO (основание к виску)'
                        break;
                    case "bu":
                        footingtext = 'BU (основание вверх)'
                        break;
                    case "bd":
                        footingtext = 'BD (основание вниз)'
                        break;
                    case undefined:
                        footingtext = ''
                        break;
                }

                $('#receiptGlassListGenerate').append('' +
                    '<div>' +
                    '<div class="row mt-2">\n' +
                    '        <strong class="col-sm-12 print__title">Рецепт на очки #'+ ((index)+1) +'</strong>\n' +
                    '    </div>' +
                    '       <table class="table mt-1 border-bottom-0 table-print newReceiptGlassBox'+index+'">\n' +
                    '                        <tr>\n' +
                    '                            <td class="border-bottom-0 receipt-td-220">\n' +
                    '                                <strong>Visus OD:</strong>\n' +
                    '                                <span class="receipt-box-100" id="receiptGlass'+index+'OD-visus-before">'+item.OD.visus.before+'</span>\n' +
                    '                            </td>\n' +
                    '                            <td class="border-bottom-0 receipt-td-220">\n' +
                    '                                <strong>Visus OS:</strong>\n' +
                    '                                <span id="receiptGlass'+index+'OS-visus-before">'+item.OS.visus.before+'</span>\n' +
                    '                            </td>\n' +
                    '<td class="border-bottom-0 receipt-td-right"><strong class="col-sm-12 form-label mt-3" id="footing'+index+'">'+footingtext+'</strong></td>' +
                    '                        </tr>\n' +
                    '                    </table>' +
                    '                        <table class="table table-bordered vision-table print__table table-print mt-1 newReceiptGlassBox'+index+'">\n' +
                    '\n' +
                    '                            <tr>\n' +
                    '                                <th class=""></th>\n' +
                    '                                <th class="vision-table-bg">sph</th>\n' +
                    '                                <th class="vision-table-bg">cyl</th>\n' +
                    '                                <th class="vision-table-bg">ax</th>\n' +
                    '                                <th class="vision-table-bg">Add</th>\n' +
                    '                                <th class="vision-table-bg">pr1</th>\n' +
                    '                                <th class="vision-table-bg">bas</th>\n' +
                    '                                <th class="vision-table-bg">pr2</th>\n' +
                    '                                <th class="vision-table-bg">bas</th>\n' +
                    '                            </tr>\n' +
                    '\n' +
                    '                            <tr>\n' +
                    '                                <td class="vision-table-title">OD</td>\n' +
                    '                                <td>\n' +
                    '                                    <span class="" id="receiptGlass'+index+'OD-sph"  >'+item.OD.sph+'</span>\n' +
                    '                                </td>\n' +
                    '                                <td>\n' +
                    '                                    <span class="" id="receiptGlass'+index+'OD-cyl" >'+item.OD.cyl+'</span>\n' +
                    '                                </td>\n' +
                    '                                <td>\n' +
                    '                                    <span class="" id="receiptGlass'+index+'OD-ax" >'+item.OD.ax+'</span>\n' +
                    '                                </td>\n' +
                    '                                <td>\n' +
                    '                                    <span class="" id="receiptGlass'+index+'OD-add">'+item.OD.add+'</span>\n' +
                    '                                </td>\n' +
                    '                                <td>\n' +
                    '                                    <span class="" id="receiptGlass'+index+'OD-pr1">'+item.OD.pr1+'</span>\n' +
                    '                                </td>\n' +
                    '                                <td>\n' +
                    '                                    <span class="" id="receiptGlass'+index+'OD-bas1">'+item.OD.bas1+'</span>\n' +
                    '                                </td>\n' +
                    '                                <td>\n' +
                    '                                    <span class="" id="receiptGlass'+index+'OD-pr2">'+item.OD.pr2+'</span>\n' +
                    '                                </td>\n' +
                    '                                <td>\n' +
                    '                                    <span class="" id="receiptGlass'+index+'OD-bas2">'+item.OD.bas2+'</span>\n' +
                    '                                </td>\n' +
                    '                            </tr>\n' +
                    '                            <tr>\n' +
                    '                                <td class="vision-table-title">OS</td>\n' +
                    '                                <td>\n' +
                    '                                    <span class="" id="receiptGlass'+index+'OS-sph"  >'+item.OS.sph+'</span>\n' +
                    '                                </td>\n' +
                    '                                <td>\n' +
                    '                                    <span class="" id="receiptGlass'+index+'OS-cyl" >'+item.OS.cyl+'</span>\n' +
                    '                                </td>\n' +
                    '                                <td>\n' +
                    '                                    <span class="" id="receiptGlass'+index+'OS-ax" >'+item.OS.ax+'</span>\n' +
                    '                                </td>\n' +
                    '                                <td>\n' +
                    '                                    <span class="" id="receiptGlass'+index+'OS-add">'+item.OS.add+'</span>\n' +
                    '                                </td>\n' +
                    '                                <td>\n' +
                    '                                    <span class="" id="receiptGlass'+index+'OS-pr1">'+item.OS.pr1+'</span>\n' +
                    '                                </td>\n' +
                    '                                <td>\n' +
                    '                                    <span class="" id="receiptGlass'+index+'OS-bas1">'+item.OS.bas1+'</span>\n' +
                    '                                </td>\n' +
                    '                                <td>\n' +
                    '                                    <span class="" id="receiptGlass'+index+'OS-pr2">'+item.OS.pr2+'</span>\n' +
                    '                                </td>\n' +
                    '                                <td>\n' +
                    '                                    <span class="" id="receiptGlass'+index+'OS-bas2">'+item.OS.bas2+'</span>\n' +
                    '                                </td>\n' +
                    '\n' +
                    '                            </tr>\n' +
                    '                        </table>\n' +
                    '       <table class="table mt-1 receipt-tab-500 table-print newReceiptGlassBox'+index+'">\n' +
                    '                        <tr>\n' +
                    '                            <td class="border-bottom-0 receipt-td-220">\n' +
                    '                                <strong>Visus OD:</strong>\n' +
                    '                                <span class="receipt-box-100" id="receiptGlass'+index+'OD-visus-after">'+item.OD.visus.after+'</span>\n' +
                    '                            </td>\n' +
                    '                            <td class="border-bottom-0 receipt-td-220">\n' +
                    '                                <strong>Visus OS:</strong>\n' +
                    '                                <span id="receiptGlass'+index+'OS-visus-after">'+item.OS.visus.after+'</span>\n' +
                    '                            </td>\n' +
                    '                        </tr>\n' +
                    '                    </table>' +
                    '         <table class="table mt-1 receipt-tab-800 newReceiptGlassBox'+index+'">\n' +
                    '                        <tr>\n' +
                    '                            <td class="border-bottom-0 receipt-td-200">\n' +
                    '                                <strong>РЦ даль OD:</strong>\n' +
                    '                                <span id="receiptGlass'+index+'OD-rc-distance">'+item.OD.rc.distance+'</span>\n' +
                    '                            </td>\n' +
                    '                            <td class="border-bottom-0 receipt-td-200">\n' +
                    '                                <strong>РЦ даль OS:</strong>\n' +
                    '                                <span id="receiptGlass'+index+'OS-rc-distance">'+item.OS.rc.distance+'</span>\n' +
                    '                            </td>\n' +
                    '                            <td class="border-bottom-0 receipt-td-200">\n' +
                    '                                <strong>РЦ близь OD:</strong>\n' +
                    '                                <span id="receiptGlass'+index+'OD-rc-near">'+item.OD.rc.near+'</span>\n' +
                    '                            </td>\n' +
                    '                            <td class="border-bottom-0 receipt-td-200">\n' +
                    '                                <strong>РЦ близь OS:</strong>\n' +
                    '                                <span id="receiptGlass'+index+'OS-rc-near">'+item.OS.rc.near+'</span>\n' +
                    '                            </td>\n' +
                    '                        </tr>\n' +
                    '                    </table>' +
                    ' <div class="col-sm-12 mt-4 table-print newReceiptGlassBox'+index+'">\n' +
                    '                        <strong class="col-sm-12  form-label mt-3">Рекомендуемая оптическая линза с покрытием: </strong>\n' +
                    '                        <span id="recommendedCoatedLens'+index+'">'+item.recommendedCoatedLens+'</span>\n' +
                    '                    </div>' +
                    '                    <div class="col-sm-12 mt-1 receiptGlassLensValidation__box'+index+' print__checkbox" >\n' +
                    '                        <table class="table">\n' +
                    '                            <tr>' +
                    '<td>' +
                    '                                    <div class="form-check">\n' +
                    '                                        <input type="checkbox" value="distanse" class="form-check-input receiptGlassLensValidation d-none" name="receiptGlass[lenses]" id="lenses'+index+'-distanse" disabled="disabled" >\n' +
                    '                                        <label class="form-check-label anketa-checkbox" for="lenses'+index+'-distanse">Даль</label>\n' +
                    '                                    </div>\n' +
                    '\n' +
                    '                                    <div class="form-check">\n' +
                    '                                        <input type="checkbox" value="reader" class="form-check-input receiptGlassLensValidation d-none" name="receiptGlass[lenses]" id="lenses'+index+'-reader" disabled="disabled" >\n' +
                    '                                        <label class="form-check-label anketa-checkbox" for="lenses'+index+'-reader">Близь</label>\n' +
                    '                                    </div>\n' +
                    '\n' +

                    '</td>' +
                    '<td>' +
                    '                                    <div class="form-check">\n' +
                    '                                        <input type="checkbox" value="constance" class="form-check-input receiptGlassLensValidation d-none" name="receiptGlass[lenses]" id="lenses'+index+'-constance" disabled="disabled" >\n' +
                    '                                        <label class="form-check-label anketa-checkbox" for="lenses'+index+'-constance">Постоянное ношение</label>\n' +
                    '                                    </div>\n' +
                    '                                    <div class="form-check">\n' +
                    '                                        <input type="checkbox" value="bifocal" class="form-check-input receiptGlassLensValidation d-none" name="receiptGlass[lenses]" id="lenses'+index+'-bifocal"disabled="disabled">\n' +
                    '                                        <label class="form-check-label anketa-checkbox" for="lenses'+index+'-bifocal">Бифокальные</label>\n' +
                    '                                    </div>\n' +

                    '</td>' +
                    '<td>' +
                    '                                    <div class="form-check">\n' +
                    '                                        <input type="checkbox" value="single" class="form-check-input receiptGlassLensValidation d-none" name="receiptGlass[lenses]" id="lenses'+index+'-single" disabled="disabled" >\n' +
                    '                                        <label class="form-check-label anketa-checkbox" for="lenses'+index+'-single">Однофокальные</label>\n' +
                    '</div>\n' +
                    '                                    <div class="form-check">\n' +
                    '                                        <input type="checkbox" value="progressive" class="form-check-input receiptGlassLensValidation d-none" name="receiptGlass[lenses]" id="lenses'+index+'-progressive" disabled="disabled">\n' +
                    '                                        <label class="form-check-label anketa-checkbox" for="lenses'+index+'-progressive">Прогрессивные</label>\n' +
                    '                                    </div>\n' +
                    '</td>' +
                    '<td>' +
                    '<div class="form-check">\n' +
                    '                                        <input type="checkbox" value="provision" class="form-check-input receiptGlassLensValidation d-none" name="receiptGlass[lenses]" id="lenses'+index+'-provision" disabled="disabled" >\n' +
                    '                                        <label class="form-check-label anketa-checkbox" for="lenses'+index+'-provision">Курс Provision</label></div>' +
                    '<div class="form-check">\n' +
                    '                                        <input type="checkbox" value="office" class="form-check-input receiptGlassLensValidation d-none" name="receiptGlass[lenses]" id="lenses'+index+'-office" disabled="disabled">\n' +
                    '                                        <label class="form-check-label anketa-checkbox" for="lenses'+index+'-office">Офисные</label></div>' +
                    '</td>' +
                    '                            </tr>\n' +
                    '                        </table>\n' +
                    '                    </div>' +
                    '</div>' +
                    '</div>');
                //убираем нули из значений
                $('.newReceiptGlassBox'+index+' span').each(function(){
                    if($(this).text() === "0"){
                        $(this).text("");
                    }
                });

                let receiptGenGlassODSph = Number(item.OD.sph);
                if(receiptGenGlassODSph > 0){
                    $('#receiptGlass'+index+'OD-sph').prepend('+')
                }


                let receiptGenGlassOSSph = Number(item.OS.sph);
                if(receiptGenGlassOSSph > 0){
                    $('#receiptGlass'+index+'OS-sph').prepend('+')
                }

                //Рецепт на очки очки линзы список checkbox
                let glassLensesGen = item.lenses;
                if(glassLensesGen !== undefined){
                    glassLensesGen.forEach((item)=>{
                        $('.receiptGlassLensValidation__box'+index+' input[value="' + item +'"]').prop('checked', true)
                    });
                }


            })/* конец цикла генерации рецептов*/

            //Рецепт на контактные линзы таблица + поля
            if(userFormData.ReceiptLens === null) {
                $('.contact-lens-delete-box').addClass('d-none');
            } else {
                let ReceiptLensODSph = Number(userFormData.ReceiptLens.OD.sph);
                if(ReceiptLensODSph > 0){
                    $('#receiptLensOD-sph').prepend('+')
                } else if(ReceiptLensODSph === 0) {
                    $('#receiptLensOD-sph').text('')
                } else {
                    $('#receiptLensOD-sph').text(userFormData.ReceiptLens.OD.sph)
                }

                //$('#receiptLensOD-sph').text(userFormData.ReceiptLens.OD.sph==='0'?'':userFormData.ReceiptLens.OD.sph);
                $('#receiptLensOD-cyl').text(userFormData.ReceiptLens.OD.cyl==='0'?'':userFormData.ReceiptLens.OD.cyl);
                $('#receiptLensOD-ax').text(userFormData.ReceiptLens.OD.ax==='0'?'':userFormData.ReceiptLens.OD.ax);
                $('#receiptLensOD-add').text(userFormData.ReceiptLens.OD.add==='0'?'':userFormData.ReceiptLens.OD.add);
                $('#receiptLensOD-bc').text(userFormData.ReceiptLens.OD.bc==='0'?'':userFormData.ReceiptLens.OD.bc);
                $('#receiptLensOD-dia').text(userFormData.ReceiptLens.OD.dia==='0'?'':userFormData.ReceiptLens.OD.dia);

                let ReceiptLensOSSph = Number(userFormData.ReceiptLens.OS.sph);
                if(ReceiptLensOSSph > 0){
                    $('#receiptLensOS-sph').text(userFormData.ReceiptLens.OS.sph).prepend('+')
                } else if(ReceiptLensOSSph === 0) {
                    $('#receiptLensOS-sph').text('')
                } else {
                    $('#receiptLensOS-sph').text(userFormData.ReceiptLens.OS.sph)
                }
                //$('#receiptLensOS-sph').text(userFormData.ReceiptLens.OS.sph==='0'?'':userFormData.ReceiptLens.OS.sph);
                $('#receiptLensOS-cyl').text(userFormData.ReceiptLens.OS.cyl==='0'?'':userFormData.ReceiptLens.OS.cyl);
                $('#receiptLensOS-ax').text(userFormData.ReceiptLens.OS.ax==='0'?'':userFormData.ReceiptLens.OS.ax);
                $('#receiptLensOS-add').text(userFormData.ReceiptLens.OS.add==='0'?'':userFormData.ReceiptLens.OS.add);
                $('#receiptLensOS-bc').text(userFormData.ReceiptLens.OS.bc==='0'?'':userFormData.ReceiptLens.OS.bc);
                $('#receiptLensOS-dia').text(userFormData.ReceiptLens.OS.dia==='0'?'':userFormData.ReceiptLens.OS.dia);

                //тип линз выборка checkbox
                let receiptLensTypeList = userFormData.ReceiptLens.type;
                let receiptLensTypeItem;
                let receiptLensTypeItemOther;
                function receiptLensTypeName(name) {
                    switch (name)
                    {
                        case "hy":
                            receiptLensTypeItem = 'Hy'
                            break;
                        case "siHy":
                            receiptLensTypeItem = 'Si-Hy'
                            break;
                        case "torica":
                            receiptLensTypeItem = 'Torica'
                            break;
                        case "other":
                            receiptLensTypeItem = 'Другие'
                            break;
                    }
                }
                receiptLensTypeList.forEach((item)=>{
                    receiptLensTypeName(item);
                    let typeOtherText;
                    if(receiptLensTypeItem === 'Другие'){
                        typeOtherText = ' (' +userFormData.ReceiptLens.typeOther+ ')'
                    } else {
                        typeOtherText = ""
                    }
                    $('#receiptLensType').append('<li>' + receiptLensTypeItem + '' + typeOtherText+'</li>')
                });

                $('#receiptLens-name').text(userFormData.ReceiptLens.name);
                $('#receiptLens-mode').text(userFormData.ReceiptLens.mode);
                $('#receiptLens-wearing').text(userFormData.ReceiptLens.wearing);
                $('#conditionCornea').text(userFormData.ReceiptLens.conditionCornea);
                $('#conditionConjunctival').text(userFormData.ReceiptLens.conditionConjunctival);
                //$('#recommendedCoatedLens').text(userFormData.ReceiptLens.recommendedCoatedLens);


                //Посадка МКЛ выборка radio
                let fitSCL = userFormData.ReceiptLens.fit;
                let fitSCLItem;
                switch (fitSCL)
                {
                    case "abrupt":
                        fitSCLItem = 'крутая'
                        break;
                    case "flat":
                        fitSCLItem = 'плоская'
                        break;
                    case "standard":
                        fitSCLItem = 'норма'
                        break;
                }
                $('#fitSCL').text(fitSCLItem)
            }



            if (this.printForm === 'print'){
                window.print();
            }
        } catch (error){
            console.debug(error)
        }

    }

    clientAge(){
        let dateNow = new Date();
        dateNow = new Date(dateNow.getFullYear(), dateNow.getMonth(), dateNow.getDate());
        let clientBirthday = $('#clientDateBirth').val();
        clientBirthday = clientBirthday.split(".");
        clientBirthday = new Date(clientBirthday[2], clientBirthday[1] - 1, clientBirthday[0]);
        clientBirthday = new Date(clientBirthday.getFullYear(), clientBirthday.getMonth(), clientBirthday.getDate());
        let clientBirthdayNow = new Date(dateNow.getFullYear(), clientBirthday.getMonth(), clientBirthday.getDate()); //ДР в текущем году

        let age;
        age = dateNow.getFullYear() - clientBirthday.getFullYear();
        if (dateNow < clientBirthdayNow) {
            age = age-1;
        }

        $('#clientAge').val(age);

    }

    async connect() {
        this.checkToken();



        /* обращаемся в твиг, указваем какой контроллер use, внутри переадем данные */
        let content = Twig.twig({ref: "userdoc"}).render({
            userAuth: this.WhoIs
        });
        /* указываем блок и выводим в него содержимое твига*/
        $('#userdoc').html(content);
        this.printForm = $('#userdoc').attr('data-form-print')
        await this.fillDoc();

        /* QR */
        let qrLink = 'https://actualoptic.kz/my-actual-online/?ref=MG2';
        if(this.lkToken !== null && this.lkToken !== undefined){
            console.log('lkToken', this.lkToken);
            qrLink = 'https://my.actualoptic.kz/?'+this.lkToken;
        }

        let canvasDoc = document.getElementById('canvas');
        qrcode.toCanvas(canvasDoc, qrLink, {  width : '90' }, function (error) {
            if (error) console.error(error)
        })

/* 10.2023 убрано:это предыдущий вариант QR - где ссылка ведет на ЛК с токеном клиента

        if (this.lkToken !== null) {
            let canvasDoc = document.getElementById('canvas');
            console.debug(canvasDoc);
            qrcode.toCanvas(canvasDoc, 'https://my.actualoptic.kz/?'+this.lkToken, {  width : '90' }, function (error) {
                if (error) console.error(error)
            })
        } else {
            $('.qr-box-main').remove();
        }
*/



        let generateReceipt = ($('#receiptGlassListGenerate>div').length);
        let lensNone = $('.contact-lens-delete-box').attr('class').replace('row recipeContactLensBox contact-lens-delete-box ','');
        if (lensNone === 'd-none'){
            if (generateReceipt === 1){
                $('#containerReceipt').addClass('noMkl2Receipt')
            }  else {
                $('#containerReceipt').removeClass('noMkl2Receipt')
            }
        }

        if (lensNone === 'd-none'){
            if (generateReceipt === 0){
                $('#containerReceipt').addClass('noMkl1Receipt')
            }  else {
                $('#containerReceipt').removeClass('noMkl1Receipt')
            }
        }

        if (lensNone === 'row recipeContactLensBox contact-lens-delete-box'){
            if (generateReceipt === 0){
                $('#containerReceipt').addClass('Mkl1Receipt')
            }  else {
                $('#containerReceipt').removeClass('Mkl1Receipt')
            }
        }

    }
}
